export default "__VITE_ASSET__fQ1Rdspi__"